import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Table, EmptyState } from 'components';
import { CellsTypes } from 'constants/index';
import { Document } from 'types';

interface EventDetailsDocumentsProps {
  documents: Document[];
}

const EventDetailsDocuments: FC<EventDetailsDocumentsProps> = ({
  documents,
}) => {
  const { t } = useTranslation();

  const tableConfig = {
    title: t('documentation.attachFiles'),
    headers: [
      {
        id: 'name',
        width: '100%',
        type: CellsTypes.DOCUMENT,
        headerType: 'title',
      },
    ],
  };

  return (
    <>
      {documents.length > 0 ? (
        <Table data={documents} config={tableConfig} />
      ) : (
        <EmptyState
          icon="📎"
          title={t('event.noDocuments.title')}
          description={t('event.noDocuments.description')}
        />
      )}
    </>
  );
};

export default EventDetailsDocuments;
